export const GAME_INFO_MODULE = {
  TYPES: {
    stadium: 'location_info',
    referee: 'ref_info',
    tvNetwork: 'tv_info',
  }
}
